module.exports = __webpack_public_path__ + "static/img/church_03.a3f4451.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/church_03.png
// module id = MMXS
// module chunks = 0